import { ReceiptBankAccountBody } from "constants/types/receipt";

export type PaymentMethod = "bank" | "cash";

export type BankAccountFormValues = ReceiptBankAccountBody & { id: string };

export const emptyBankAccount = (): BankAccountFormValues => ({
  id: "",
  bankName: "",
  accountNumber: "",
  accountHolder: "",
  isActive: true,
});
